import React, { useContext, useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { isEmpty } from 'lodash';
import { Container } from './styles/Container.styled';
import { SectionHeadline } from './styles/SectionHeadline.styled';
import {
  WhatsHappingCarousel,
  Slide,
  SliderEvents,
  EventDescription,
} from './styles/FullWidthSlider.styled';
import DatePickerContext from '../context/DatePickerContext';
import { isCurrDate } from '../helpers/date-convert';
import ExternalEvents from '../services/ExternalEvents';

export default function WhatsHappeningSameMonth({ dir, eventMonth, eventYear }) {
  const { month, year } = useContext(DatePickerContext);
  const [filteredData, setFilteredData] = useState([]);
  const isArabic = dir === 'rtl';

  const currMonth = eventMonth || month;
  const currYear = eventYear || year;

  useEffect(() => {
    const featchApiData = () => {
      const apiData = ExternalEvents();
      apiData
        .then((res) => {
          const parsed = JSON.parse(res);
          const currEventsArr = isArabic ? parsed.data.eventsAr : parsed.data.eventsEn;
          const filtered = currEventsArr.filter((event) =>
            isCurrDate(currMonth, currYear, event.startDate, event.endDate),
          );
          setFilteredData(filtered);
        })
        .catch(() => {
          setFilteredData([]);
        });
    };
    featchApiData();
  }, [month, year]);

  const titleText =
    dir === 'rtl' ? 'فعاليات تقام في هذا الشهر' : "Other events happening in Dubai";

  const settings = {
    slidesToShow: filteredData.length > 4 ? 5 : filteredData.length,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3500,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: filteredData.length > 2 ? 3 : filteredData.length,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: filteredData.length > 1 ? 2 : filteredData.length,
        },
      },
      {
        breakpoint: 675,
        settings: {
          arrows: false,
          slidesToShow: 1,
          autoplay: false,
        },
      },
    ],
  };

  return (
    <WhatsHappingCarousel dir={dir}>
      <Container>
        <SectionHeadline>
          <h2 dir={dir}>{titleText}</h2>
        </SectionHeadline>
        <Slider {...settings}>
          {isEmpty(filteredData) ||
            filteredData.map((event) => (
              <Slide dir={dir} href={event.website}>
                <SliderEvents to={event.website} target="_blank">
                  <LazyLoadImage src={event.fallbackImage} effect="blur" />
                  <EventDescription dir={dir}>
                    <h3>{event.title}</h3>
                    <span dir={dir}>{isEmpty(event.tags[0]) || event.tags[0].name}</span>
                  </EventDescription>
                </SliderEvents>
              </Slide>
            ))}
        </Slider>
      </Container>
    </WhatsHappingCarousel>
  );
}
